interface ProgressBarProps {
  percent: number;
  label?: string | null;
  className?: string;
}

export function ProgressBar({ percent, label, className = "" }: ProgressBarProps) {
  const clamped = Math.max(0, Math.min(100, percent));
  return (
    <div className={`space-y-1 ${className}`}>
      {label ? <p className="text-sm text-label-secondary">{label}</p> : null}
      <div
        className="h-2 w-full overflow-hidden rounded-full bg-fill"
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label ?? "Fortschritt"}
      >
        <div
          className="h-full rounded-full bg-accent transition-[width] duration-300 ease-out"
          style={{ width: `${clamped}%` }}
        />
      </div>
      <p className="text-xs tabular-nums text-label-tertiary">{clamped} %</p>
    </div>
  );
}
